const page_schema = {
	"tiers": [
		{
			"name": "Type",
			"type": "checkbox",
			"id": "types",
			"class_name": "tags",
			"child_name": "type",
			"options": [
				{
					"name": "Bacterial 16S",
					"id": "bacterial-16s"
				},
				{
					"name": "Fungal ITS",
					"id": "fungal-its"
				},
				// {
				// 	"name": "Shotgun Metagenomics",
				// 	"id": "shotgun-metagenomics"
				// },
			]
		},
		{
			"name": "Region",
			"type": "checkbox",
			"id": "regions",
			"class_name": "tags",
			"child_name": "region",
			"options": [
				{
					"name": "16S V1-V2",
					"id": "16s-v1-v2"
				},
				{
					"name": "16S V1-V3",
					"id": "16s-v1-v3"
				},
				{
					"name": "16S V3-V4",
					"id": "16s-v3-v4"
				},
				{
					"name": "16S V4",
					"id": "16s-v4"
				},
				{
					"name": "ITS2",
					"id": "its2"
				},
				{
					"name": "16S Full-Length",
					"id": "16s-full-length"
				},
			]
		},
		{
			"name": "Features",
			"type": "checkbox",
			"id": "features",
			"class_name": "tags",
			"child_name": "feature",
			"options": [
				{
					"name": "Auto-normalization",
					"id": "auto-normalization"
				},
				{
					"name": "Customizable Primers",
					"id": "customizable-primers"
				},
				{
					"name": "1-Step PCR",
					"id": "1-step-pcr"
				},
				{
					"name": "Unique Dual Index",
					"id": "unique-dual-index"
				},
				{
					"name": "Combinatorial Index",
					"id": "combinatorial-index"
				},
			]
		},
	],
	"filters": [],
	"products": {
		"Quick-16S NGS Library Prep Kit": {
			"title": "<i>Quick</i>-16S NGS Library Prep Kit",
			"catalogNumbers": "D6400",
			"description": "Microbial composition profiling techniques powered by Next-Generation sequencing are becoming routine in microbiomics and metagenomics studies. However, these analytical techniques can suffer from significant bias from collection to analysis. The ZymoBIOMICS Microbial Community Standard is designed to assess bias and errors in the extraction methods of a microbiomics workflow. The Microbial Community Standard mimics a mixed microbial community of well-defined composition, containing three easy-to-lyse Gram-negative bacteria, five tough-to-lyse Gram-positive bacteria, and two tough-to-lyse yeasts. Acting as a defined input from the beginning, the Microbial Community Standard can guide construction and optimization of entire workflows and can also be used as a routine quality control. Theoretical Composition Based on Genomic DNA: Listeria monocytogenes - 12%, Pseudomonas aeruginosa - 12%, Bacillus subtilis - 12%, Escherichia coli - 12%, Salmonella enterica - 12%, Lactobacillus fermentum - 12%, Enterococcus faecalis - 12%, Staphylococcus aureus - 12%, Saccharomyces cerevisiae - 2%, and Cryptococcus neoformans - 2%.",
			"handle": "/products/quick-16s-ngs-library-prep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6400_Quick-16S_20NGS_20Library_20Prep_20Kit.png?v=1628532355&width=600",
			"generalIndex": "998",
			"tags": [
				"bacterial-16s",
				"16s-v1-v2",
				"16s-v3-v4",
				"customizable-primers",
				"combinatorial-index",
			],
			filters: []
		},
		"Quick-16S Plus NGS Library Prep Kit (V4)": {
			"title": "<i>Quick</i>-16S Plus NGS Library Prep Kit (V4)",
			"catalogNumbers": "D6430-PS1, D6430-PS2, D6430-PS3, D6430-PS4, D6432",
			"description": "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V4) is the fastest and simplest NGS library prep targeting the V4 region of the 16S rRNA gene for high-throughput sequencing. The automation-friendly protocol utilizes a premixed amplification plate and a single qPCR/PCR for combined targeted amplification and barcode addition. Pooling by equal volume and a single clean-up of the final library, rather than massive AMPure® bead-based clean-ups, simplifies the library prep process. Additional library quantification analysis such as TapeStation® analysis or gel electrophoresis are not necessary. With these features, the workflow dramatically reduces the hands-on time of library preparation to only 30 minutes.",
			"handle": "/products/quick-16s-plus-ngs-library-prep-kit-v4",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6430_Quick-16S-Plus-NGS-Library-Prep-Kit-_V4.jpg?v=1658345576&width=600",
			"generalIndex": "998",
			"tags": [
				"bacterial-16s",
				"16s-v4",
				"auto-normalization",
				"1-step-pcr",
				"unique-dual-index",
			],
			filters: []
		},
		"Quick-ITS Plus NGS Library Prep Kit (UDI)": {
			"title": "<i>Quick</i>-ITS Plus NGS Library Prep Kit (UDI)",
			"catalogNumbers": "D6425-PS1, D6425-PS2, D6425-PS3, D6425-PS4",
			"description": "Quick-ITS Plus NGS Library Prep Kit (UDI) is the fastest and simplest NGS library prep targeting the ITS region for high-throughput sequencing. The automation-friendly protocol utilizes a single qPCR/PCR for combined targeted amplification and barcode addition using specially designed primers. After pooling by equal volume, a single clean-up of the final library is performed, rather than massive AMPure® bead-based clean-ups. Additional library quantification analysis such as TapeStation® analysis or gel electrophoresis are not necessary. With these features, the workflow dramatically reduces the hands-on time of library preparation to only 30 minutes.",
			"handle": "/products/quick-its-plus-ngs-library-prep-kit-udi",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d6424-quick_its_plus_ngs_library_prep_kit.jpg?v=1628532419&width=600",
			"generalIndex": "998",
			"tags": [
				"fungal-its",
				"its2",
				"auto-normalization",
				"1-step-pcr",
				"unique-dual-index",
			],
			filters: []
		},
		"Quick-16S Plus NGS Library Prep Kit (V3-V4, UDI)": {
			"title": "<i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI)",
			"catalogNumbers": "D6421-PS1, D6421-PS2, D6421-PS3, D6421-PS4, D6421-PS5, D6421-PS6, D6421-PS7, D6421-PS8",
			"description": "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI) is the fastest and simplest NGS library prep targeting the V3-V4 region of the 16S rRNA gene for high-throughput sequencing. The automation-friendly protocol utilizes a single qPCR/PCR for combined targeted amplification and barcode addition using specially designed primers. After pooling by equal volume, a single clean-up of the final library is performed, rather than massive AMPure® bead-based clean-ups. Additional library quantification analysis such as TapeStation® analysis or gel electrophoresis are not necessary. With these features, the workflow dramatically reduces the hands-on time of library preparation to only 30 minutes.",
			"handle": "/products/quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/d6420-quick_16s_plus_ngs_library_prep_kit_5760x5760_b92f8884-354d-48bf-9660-e41bd948cd3f.jpg?v=1690506528&width=600",
			"generalIndex": "998",
			"tags": [
				"bacterial-16s",
				"16s-v3-v4",
				"auto-normalization",
				"1-step-pcr",
				"unique-dual-index",
			],
			filters: []
		},
		"Quick-16S Plus NGS Library Prep Kit (V1-V2)": {
			"title": "<i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V2)",
			"catalogNumbers": "D6434-PS1",
			"description": "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V2) is the fastest and simplest NGS library prep targeting the V1-V2 region of the 16S rRNA gene for high-throughput sequencing. The automation-friendly protocol utilizes a single qPCR/PCR for combined targeted amplification and barcode addition using specially designed primers. After pooling by equal volume, a single clean-up of the final library is performed, rather than massive AMPure® bead-based clean-ups. Additional library quantification analysis such as TapeStation® analysis or gel electrophoresis are not necessary. With these features, the workflow dramatically reduces the hands-on time of library preparation to only 30 minutes.",
			"handle": "/products/quick-16s-plus-ngs-library-prep-kit-v1-v2",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/D6434Quick-16SNGSLibraryPrepKit_V1-V2.jpg?v=1701709549",
			"generalIndex": "998",
			"tags": [
				"bacterial-16s",
				"16s-v1-v2",
				"auto-normalization",
				"1-step-pcr",
				"unique-dual-index",
			],
			filters: []
		},
		"Quick-16S Plus NGS Library Prep Kit (V1-V3)": {
			"title": "<i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V3)",
			"catalogNumbers": "D6440-PS1, D6440-PS2, D6440-PS3, D6440-PS4",
			"description": "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V3) is the fastest and simplest NGS library prep targeting the V1-V3 region of the 16S rRNA gene for high-throughput sequencing. The automation-friendly protocol utilizes a single qPCR/PCR for combined targeted amplification and barcode addition using specially designed primers. After pooling by equal volume, a single clean-up of the final library is performed, rather than massive AMPure® bead-based clean-ups. Additional library quantification analysis such as TapeStation® analysis or gel electrophoresis are not necessary. With these features, the workflow dramatically reduces the hands-on time of library preparation to only 30 minutes.",
			"handle": "/products/quick-16s-plus-ngs-library-prep-kit-v1-v3",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/D6440Quick-16SNGSLibraryPrepKit_V1-V3.jpg?v=1701709564",
			"generalIndex": "998",
			"tags": [
				"bacterial-16s",
				"16s-v1-v3",
				"auto-normalization",
				"1-step-pcr",
				"unique-dual-index",
			],
			filters: []
		},
		"Quick-16S/ITS NGS Library Prep Kit Sampler": {
			"title": "<i>Quick</i>-16S/ITS NGS Library Prep Kit Sampler",
			"catalogNumbers": "D6499",
			"description": "The <i>Quick</i>-16S/ITS™ NGS Library Prep Sampler provides 8 reactions from each of our <i>Quick</i>-16S/ITS™ Plus library prep kits as well as our Quick -16S™ Full-Length Library Prep Kit. Sample the Microbiomics library prep kit portfolio in one convenient format.",
			"handle": "/products/quick-16s-its-ngs-library-prep-sampler",
			"navigation_image": "https://files.zymoresearch.com/images/filter_page/microbiome/D6499.webp",
			"generalIndex": "998",
			"id": "quick-16s-its-ngs-library-prep-sampler",
			"tags": [
				"bacterial-16s",
				"fungal-its",
				"16s-v1-v2",
				"16s-v1-v3",
				"16s-v3-v4",
				"16s-v4",
				"its2",
				"auto-normalization",
				"1-step-pcr",
				"unique-dual-index",
				"combinatorial-index",
			],
			filters: []
		},
		"Quick-16S Full-Length Library Prep Kit": {
			"title": "<i>Quick</i>-16S Full-Length Library Prep Kit",
			"catalogNumbers": "D6450-PS1, D6450-PS2, D6450-PS3, D6450-PS4",
			"description": "The <i>Quick</i>-16S Full-Length Library Prep Kit delivers pooled and purified libraries ready for downstream sequencing on PacBio & Oxford Nanopore sequencing platforms in as little as 30 minutes of hands-on time.",
			"handle": "/products/quick-16s-full-length-library-prep-kit",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/files/D6450-BQuick-16SFullLengthLibraryKit_600x.webp",
			"generalIndex": "998",
			"id": "quick-16s-full-length-library-prep-kit",
			"tags": [
				"bacterial-16s",
				"combinatorial-index",
				"16s-full-length",
			],
			filters: []
		},
	}
}